import { Subject } from 'rxjs';

import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  public currentDate = new Date();
  public startDate: Date;
  public endDate: Date;

  private dateStartSource = new Subject<Date>();
  private dateEndSource = new Subject<Date>();
  private dateAllSource = new Subject<Date>();

  public dateStart$ = this.dateStartSource.asObservable();
  public dateEnd$ = this.dateEndSource.asObservable();
  public dateAll$ = this.dateAllSource.asObservable();
  public onShowMapEvent: EventEmitter<void> = new EventEmitter();

  constructor() {
    this.endDate = new Date();
    this.endDate.setTime(this.endDate.getTime() + 30 * 24 * 60 * 60 * 1000);

    this.startDate = new Date();
    this.startDate.setTime(this.startDate.getTime() - 7 * 24 * 60 * 60 * 1000);
  }

  setAllDate(date: Date) {
    this.startDate = date;
    this.endDate = date;
    this.dateAllSource.next(date);
  }

  setStartDate(date: Date) {
    this.startDate = date;
    this.dateStartSource.next(date);
  }

  setEndDate(date: Date) {
    this.endDate = date;
    this.dateEndSource.next(date);
  }
}
